import { Content } from 'src/contexts/ContentContext';
import { PosFormField } from 'src/core/POS/PosFormField';
import { PosSelect } from 'src/core/POS/PosSelect';
import { ContentId } from 'src/utils/constants/contentId';

export type CountrySelectProps = {
  value: string;
  options: Record<string, string>;
  onChange: (value: string) => void;
  loading?: boolean;
};

export function CountrySelect({
  value,
  options,
  onChange,
  loading,
}: CountrySelectProps) {
  return (
    <PosFormField label={<Content id={ContentId.Country} />}>
      <PosSelect
        style={{ width: '100%' }}
        valueOptionsContent={options}
        value={value}
        onChange={onChange}
        placeholderText={ContentId.SelectCountry}
        loading={loading}
        searchable
        enableEmptySelection
      />
    </PosFormField>
  );
}
